import initAppearAnim from './utils/appear-anim';
import initDropdownGrid from './utils/dropdown-grid';
// import initParallax from './utils/parallax';
// import initModals from './components/modal';
import initNav from './components/navigation';
import initInputCustom from './components/input-custom';
import initCategoriesNav from './components/categories-nav';
import initMarques from './blocks/marques';
import initTemoignages from './blocks/temoignages';
import initMaillagesArticles from './blocks/maillage-articles';
import initValeurs from './blocks/valeurs';
import initHeaderAccueil from './blocks/header-accueil';
import initCarouselImages from './blocks/carousel-images';
import initTabsVertical from './blocks/tabs-vertical';
import initOrganigrammes from './blocks/organigramme';
import initMaillagesCustom from './blocks/maillage-custom';
import initBanner from './blocks/banner';
import initAjaxFilter from './utils/ajax-filter';


// Fix de la valeur de "100vh" pour les appareils iOS + Fix de la valeur de "100vw"
function appHeight() {
    const vh = (window.innerHeight * 0.01) * 100;
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const vw = document.body.clientWidth;
    document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('load', appHeight);
window.addEventListener('resize', appHeight);


// Utils
initAppearAnim();
initDropdownGrid();
initAjaxFilter();
// initParallax();

// Modules
initNav();

// Blocks
initHeaderAccueil();
initMarques();
initTemoignages();
initMaillagesArticles();
initValeurs();
initCarouselImages();
initTabsVertical();
initOrganigrammes();
initMaillagesCustom();
initBanner();

//TEMPLATE PARTS

// Components (En dernier sinon les bouton modals dans un swiper ne s'initialise pas)
initInputCustom();
// initModals();
initCategoriesNav();


